import {
    AuthContext,
    TAuthContext,
} from "@timeedit/ui-components/components/AuthWrapper/AuthWrapper";
import { ComponentType, useContext } from "react";

// HOC for class components
export const withAuthContext =
    <Props extends Record<string, any>>(
        WrappedComponent: ComponentType<Props & { authContext: TAuthContext }>
    ) =>
    (props: Props) =>
        (
            <WrappedComponent
                {...{
                    authContext: useContext(AuthContext)!,
                    ...props,
                }}
            />
        );

export type TAuthContextProp = { authContext: TAuthContext };
